import React from 'react'
import AddTreatment from '../../containers/treatments/AddTreatment';
import UsersProvider from '../../store/users/usersProvider';
import ClinicsProvider from '../../store/clinics/clinicsProvider';
import TreatmentsProvider from '../../store/treatments/treatmentsProvider';
import PageWrapper from '../../containers/app/PageWrapper';

function AddTreatmentPage() {
  return (
    <UsersProvider>
      <ClinicsProvider>
        <TreatmentsProvider>
          <PageWrapper navbar title='Add treatment'>
            <AddTreatment />
          </PageWrapper>
        </TreatmentsProvider>
      </ClinicsProvider>
    </UsersProvider>
  )
}

export default AddTreatmentPage
